import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69c4a12d7d947e00141f797b/rinse_1774493997096/node_modules/next/dist/client/app-dir/link.js");
